import { Box, Divider, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";

function Template({ headProps, children, primaryHeading, secondaryHeading }) {
  return (
    <Paper sx={{ borderRadius: 1 }}>
      <Stack
        p={2}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Stack gap={2} direction={"row"} alignItems={"center"}>
          <img
            src={allIcons.cardIcon}
            alt={"card-icon"}
            width={30}
            height={30}
          />
          <Box>
            <Typography
              variant={"body1"}
              fontWeight={600}
              lineHeight={"normal"}
            >
              {primaryHeading}
            </Typography>
            <Typography
              variant={"body2"}
              fontSize={"0.75rem"}
              color={appcolors.crayolaGrey}
            >
              {secondaryHeading}
            </Typography>
          </Box>
        </Stack>
        {headProps && (
          <Box mt={2} width="100%">
            {headProps}
          </Box>
        )}
      </Stack>
      <Divider />
      <Box
        p={"8px 16px"}
        sx={{
          height: "400px",
          overflow: "auto",
        }}
      >
        {children}
      </Box>
    </Paper>
  );
}

export default Template;
